import React, { useEffect, useState } from "react";
import "./leaderboard.css";

// IMAGE IMPORTING
import UserFaceAlt from "../../assets/img/avatar-face.jpg";
import MegaPrize from "../../assets/img/mega-prize-banner.png";
import Prize3 from "../../assets/img/weekly_winner.png";
import UserFace from "../../assets/img/avatar-face.jpg";
import profile_image from "../../utilities/constants.json";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";

import { userDetails } from "../../services/MainApiDetails";
import { User } from "../../actions";
import { Link, useNavigate } from "react-router-dom";
import ContestWinners from "../../components/contestWinners/ContestWinners"

import Prize4 from "../../assets/img/daily_winner.png";
import RankItem from "../rankItem/RankItem";
import { formatLabel } from "../../utilities/string";

const imageUrl = profile_image.profile_image;

const Leaderboard = (prop) => {
  const userProfile = useSelector((state) => state.userData.items);

  const leaderboardData = useSelector((state) => state.leaderboard.items);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    getUserDetails();
  }, []);
  function getUserDetails() {
    if (userProfile.length == 0 && localStorage.webKey) {
      userDetails().then((response) => {
        if (response.data.status === 1) {
          dispatch(User(response.data.user_data));
        }
      });
    }
  }

  function getDailyRanks() {
    let users = [];
    if (prop.type == 1) {
      users =
        leaderboardData[0] && leaderboardData[0].daily_ranks
          ? leaderboardData[0].daily_ranks
          : [];
    } else {
      users =
        leaderboardData[0] && leaderboardData[0].all_time_ranks
          ? prop.allTimeWinners?.length > 0 ? leaderboardData[0].all_time_ranks?.filter((data)=>
            !prop.allTimeWinners?.some(winner => winner?.user?._id?.$oid === data?.user_id)
          ):leaderboardData[0].all_time_ranks
          : [];
    }

    return users.map((ranks, index) => {
      return <RankItem index={index} ranks={ranks} type={prop.type} key={index}/>
    });
  }
  return (
    <div className="leaderboard">
      <div className="leaderboard-wrapper">
        {prop.type != 2 ? (
          <>
            {leaderboardData[0]?.winners?.length >0 ? (
              <div className="leaderboard-topSection">
                <div className="leaderboard-top-wrapper">
                  <div className="leaderboard-top-part1">
                    <h6>
                      {formatLabel(prop.day)} <span>Winner</span>
                    </h6>
                    <h6 className="date" onClick={prop.onDateClick}>
                                          {formatLabel(prop.day)}
                    </h6>
                    {/* <div className="sponsor-image-wrapper">
                  <img src={Logo} alt="" />
                </div> */}
                  </div>

                  {prop.type == 1 && leaderboardData[0] ? (
                    leaderboardData[0].winners ? (
                      <>
                        {leaderboardData[0].winners?.length > 0 && (
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div className={`leaderboard-top-part2 leaderboard-top-part2--${leaderboardData[0].winners.length}`}>
                              {leaderboardData[0].winners.map((winner) => (
                                <div
                                  className="leaderboard-playerThree"
                                  onClick={() => {
                                    if (
                                      localStorage.webKey &&
                                      winner?.login_status !== "Delete"
                                    )
                                      navigate("/mobile-user-profile", {
                                        state: { user_id: winner?._id?.$oid },
                                      });
                                  }}
                                >
                                  <div className="playerImg">
                                    <img
                                      src={
                                        winner.image
                                          ? imageUrl + winner.image
                                          : UserFace
                                      }
                                      alt=""
                                      onError={(e) =>
                                        (e.target.onerror = null)(
                                          (e.target.src = UserFace),
                                        )
                                      }
                                    />
                                  </div>
                                  <p className="playerName">{winner.name}</p>
                                  <p className="playerPoints">
                                    {winner.score} Pts
                                  </p>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
{/* 
                        {!leaderboardData[0].winners?.length && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              width: "50%",
                            }}
                          >
                            <div
                              className="winner-prizeImg"
                              style={{ height: "45%", width: "45%" }}
                            >
                              <img src={Prize4} alt="" />
                            </div>
                          </div>
                        )} */}

                        {userProfile &&
                        leaderboardData[0].user_daily_rank[0] &&
                        leaderboardData[0].winners.find(
                          (item) =>
                            item._id.$oid ==
                            leaderboardData[0].user_daily_rank[0].user_id,
                        ) ? (
                          <div className="leaderboard-top-part3">
                            <div className="leaderboard-winnerShow-wrapper">
                              <h3>Congrats!!!</h3>
                              <p>You are the match day winner.</p>
                              {/*<button>*/}
                              {/*  <div className="share-icon">*/}
                              {/*    <img src={ShareIcon} alt="" />*/}
                              {/*  </div>*/}
                              {/*  SHARE WITH FRIENDS*/}
                              {/*</button>*/}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : (
              <>
               {prop.type === 1 && <div className="leaderboard-top-wrapper">
                  <div className="leaderboard-top-part1">
                    <h6>
                      <span>Leaderboard</span>
                    </h6>
                    <h6 className="date" onClick={prop.onDateClick}>
                      {formatLabel(prop.day)}
                    </h6>
                  </div>
                </div>}
              {!!prop.allTimeWinners?.length ?
              <>
                  <ContestWinners allTimeWinners={prop.allTimeWinners}/>
                    <div
                  // className="leaderboard-prizeWrapper"
                  style={{ padding: "6px" }}
                >
                  {/* <div className="leaderboard-prize-list"> */}
                    {/* <br /> */}
                    {/* <div className="row"> */}
                      {/* <div className="col-12"> */}
                        {/* <div className="winner-megaPrizeImg" onClick={()=>navigate("/mobile-prizes")}>
                          <img src={MegaPrize} alt="" />
                        </div> */}
                      {/* </div> */}
                    {/* </div> */}
                  {/* </div> */}
                </div>
                </>:
                  prop.type ===1 ?(<p style={{ textAlign: "center", margin: "6px 0 2px", color: "var(--color-text-muted)", fontFamily: "Manrope", fontWeight: 400, fontSize: "11px" }}>
                    {leaderboardData[0]?.daily_ranks?.length > 0 ? "Winner yet to be announced" : "Leaderboard updates once answers are confirmed"}
                  </p>):<></>
                // <div
                //   className="leaderboard-prizeWrapper"
                //   style={{ padding: "6px" }}
                // >
                //   <div className="leaderboard-prize-list">
                //     <br />
                //     <div className="row">
                //       <div className="col-12">
                //         <div className="winner-megaPrizeImg">
                //           <img src={MegaPrize} alt="" />
                //         </div>
                //       </div>
                //     </div>
                //     <div className="leaderboard-seePrizes">
                //       <p>
                //         <Link to="/mobile-prizes">View all prizes</Link>
                //       </p>
                //     </div>
                //   </div>
                // </div>
                }
              </>
            )}
            <div className="leaderboard-middleSection">
              <div className="leaderboard-middle-wrapper">
                {getDailyRanks()}
              </div>
            </div>

            <div className="leaderboard-bottomSection">
              <div className="leaderboard-bottom-wrapper">
                {prop.type == 1 &&
                leaderboardData[0] &&
                leaderboardData[0].user_daily_rank &&
                leaderboardData[0].user_daily_rank[0] ? (
                  <>
                    <div className="leaderboard-currentPlayer-wrapper">
                      <div className="currentPlayerInfo">
                        <div className="currentPlayerImg">
                          <img
                            src={
                              leaderboardData[0].user_daily_rank[0] &&
                              leaderboardData[0].user_daily_rank[0].user.image
                                ? imageUrl +
                                  leaderboardData[0].user_daily_rank[0].user
                                    .image
                                : UserFaceAlt
                            }
                            alt=""
                            onError={(e) =>
                              (e.target.onerror = null)(
                                (e.target.src = UserFaceAlt),
                              )
                            }
                          />
                        </div>
                        <p className="currentPlayerName">
                          {leaderboardData[0].user_daily_rank[0]
                            ? leaderboardData[0].user_daily_rank[0].user.name >
                              15
                              ? `${leaderboardData[0].user_daily_rank[0].user.name.substring(
                                  0,
                                  15,
                                )}...`
                              : leaderboardData[0].user_daily_rank[0].user.name
                            : ""}
                        </p>
                      </div>
                      <p className="currentPlayerPoints">
                        {leaderboardData[0].user_daily_rank[0]
                          ? leaderboardData[0].user_daily_rank[0].score
                          : 0}{" "}
                        Pts
                      </p>
                      <div className="currentPlayerRank-wrapper">
                        <p className="currentPlayerRank">
                          {leaderboardData[0].user_daily_rank[0]
                            ? leaderboardData[0].user_daily_rank[0].daily_rank
                            : 0}
                        </p>
                      </div>
                    </div>
                  </>
                ) : prop.type == 3 &&
                  leaderboardData[0] &&
                  leaderboardData[0].user_all_time_rank &&
                  leaderboardData[0].user_all_time_rank[0] ? (
                  <>
                    <Link
                      className="leaderboard-currentPlayer-wrapper"
                      to={localStorage.webKey ? "/mobile-user-profile" : "#"}
                      state={{
                        rank: leaderboardData[0].user_all_time_rank[0]
                          ? leaderboardData[0].user_all_time_rank[0]
                              .all_time_rank
                          : 0,
                        user_id: leaderboardData[0].user_all_time_rank[0]
                          ? leaderboardData[0].user_all_time_rank[0].user._id
                              .$oid
                          : "",
                      }}
                    >
                      <div className="currentPlayerInfo">
                        <div className="currentPlayerImg">
                          <img
                            src={
                              leaderboardData[0].user_all_time_rank[0]
                                ? leaderboardData[0].user_all_time_rank[0].user
                                    .image
                                  ? imageUrl +
                                    leaderboardData[0].user_all_time_rank[0]
                                      .user.image
                                  : UserFaceAlt
                                : ""
                            }
                            alt=""
                            onError={(e) =>
                              (e.target.onerror = null)(
                                (e.target.src = UserFaceAlt),
                              )
                            }
                          />
                        </div>
                        <p className="currentPlayerName">
                          {leaderboardData[0].user_all_time_rank[0]
                            ? leaderboardData[0].user_all_time_rank[0].user
                                .name > 15
                              ? `${leaderboardData[0].user_all_time_rank[0].user.name.substring(
                                  0,
                                  15,
                                )}...`
                              : leaderboardData[0].user_all_time_rank[0].user
                                  .name
                            : ""}
                        </p>
                      </div>
                      <p className="currentPlayerPoints">
                        {leaderboardData[0].user_all_time_rank[0]
                          ? leaderboardData[0].user_all_time_rank[0].score
                          : 0}{" "}
                        Pts
                      </p>
                      <div className="currentPlayerRank-wrapper">
                        <p className="currentPlayerRank">
                          {leaderboardData[0].user_all_time_rank[0]
                            ? leaderboardData[0].user_all_time_rank[0]
                                .all_time_rank
                            : 0}
                        </p>
                      </div>
                    </Link>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {/* WEEKLY WINNERS */}
        {prop.type == 2 &&
        leaderboardData[0] &&
        !!leaderboardData[0]?.weekly_winners?.length ? (
          <div className="leaderboard-topSection" style={{ marginTop: 0 }}>
            <div className="leaderboard-top-wrapper">
              <div className="leaderboard-top-part1">
                <h6>
                  {prop.weekNumber} <span>Winner</span>
                </h6>
                <h6 className="week" onClick={prop.onWeekClick}>
                  {leaderboardData[0]?.start_date_qatar
                    ? Moment(
                        leaderboardData[0].start_date_qatar,
                        "YYYY-MM-DD",
                      ).format("DD MMM") +
                      " - " +
                      Moment(
                        leaderboardData[0].end_date_qatar,
                        "YYYY-MM-DD",
                      ).format("DD MMM")
                    : ""}{" "}
                </h6>
              </div>
              <>
                <div className="leaderboard-top-part2">
                  <div
                    style={{ width: "100%" }}
                    className="row m-0 pb-3 d-flex justify-content-center align-items-center"
                  >
                    {(leaderboardData[0]?.weekly_winners).map((item) => (
                      <div className="col-8 pt-3">
                        <div
                          className="leaderboard-playerThree"
                          onClick={() => {
                            if (localStorage.webKey && item?.login_status !== "Delete")
                              navigate("/mobile-user-profile", {
                                state: { user_id: item?._id?.$oid },
                              });
                          }}
                        >
                          <div className="playerImg">
                            <img
                              src={
                                item.image ? imageUrl + item.image : UserFace
                              }
                              alt=""
                              onError={(e) =>
                                (e.target.onerror = null)(
                                  (e.target.src = UserFace),
                                )
                              }
                            />
                          </div>
                          <p className="playerName">{item.name}</p>
                          <p className="playerPoints">{item.score} Pts</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="leaderboard-prizeWrapper pt-3">
                  <div className="leaderboard-prize-list">
                    <div
                      className="row"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      {/*<div className="col-5">*/}
                      {/*  <div className="leaderboard-prizeImg">*/}
                      {/*    <img src={Prize2} alt="" />*/}
                      {/*  </div>*/}
                      {/*</div>*/}
                    </div>
                    <div className="leaderboard-seePrizes">
                      <p>
                        {/* <Link to="/mobile-prizes">View all prizes</Link> */}
                      </p>
                    </div>
                  </div>
                </div>
                {leaderboardData[0]?.is_winner ? (
                  <div className="leaderboard-top-part3">
                    <div className="leaderboard-winnerShow-wrapper">
                      <h3>Congrats!!!</h3>
                      <p>You are a weekly winner.</p>
                      {/*<p>Mention prize</p>*/}
                      {/*<button>*/}
                      {/*  <div className="share-icon">*/}
                      {/*    <img src={ShareIcon} alt="" />*/}
                      {/*  </div>*/}
                      {/*  SHARE WITH FRIENDS*/}
                      {/*</button>*/}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </>
            </div>
          </div>
        ) : prop.type == 2 ? (
          <div style={{ textAlign: "center", padding: "40px 20px", color: "var(--color-text-primary)", opacity: 0.6, fontFamily: "Manrope", fontWeight: 600, fontSize: "14px" }}>
            Weekly winner will be announced soon
          </div>
        ) : (
          ""
        )}
        {/* WEEKLY WINNERS */}
      </div>
    </div>
  );
};

export default Leaderboard;
